import { SyncErrorsList } from "./SyncErrorsList";

export default SyncErrorsList;
